#@import GliveBooking.Presenters.PricePicker
#@import GliveBooking.Views.Picker
#@import GliveBooking.Views.Prices
#@export GliveBooking.Views.PricePicker

class GliveBooking.Views.PricePicker extends GliveBooking.Views.Picker

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.PricePicker

  contentView: GliveBooking.Views.Prices

  templateName: 'pricepicker'

  attributes: ->
    'data-bhw': "#{GliveBooking.bhw}Prices"

  styleClassName: 'prices'
